import {
	Grow,
	Modal,
	Table,
	TableBody,
	TableContainer,
	TableHead,
	TableRow
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import UpIcon from '@material-ui/icons/KeyboardArrowUp';
import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from 'react-intl';
import { Redirect } from 'react-router-dom';
import swal from 'sweetalert';
import jzip from 'xlsx/dist/jszip';
import 'xlsx/dist/xlsx.full.min.js';
import '../../assets/css/vec-datatables.css';
import LimpiarFiltros from '../../assets/images/limpiar-filtros.svg';
import LogoCompany from '../../assets/images/logo-company.png';
import LogoVecFleet from '../../assets/images/logo-vecfleet.png';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import Security from '../../commons/security/Security.js';
import Timezone from '../../commons/timezone/Timezone.js';
import { StyledTableCellProps as StyledTableCell, StyledTooltip } from '../../commons/utils/TableStyles';
import * as Utils from '../../commons/utils/Utils';
import TicketCards from "./TicketCards.jsx";
import AccionesMasivas from './TicketGridAccionesMasivas';
import TicketGridFilters from './TicketGridFilters';
import TicketsCerradosImportar from "./TicketsCerradosImportar.jsx";
import TicketsCerradosImportarReporte from "./TicketsCerradosImportarReporte.jsx";
import TicketsGridExport from './TicketsGridExport';
import TicketsGridRow from './TicketsGridRow';
import TicketsGridTableRow from './TicketsGridTableRow';
import swal2 from 'sweetalert2';
import { buildEmptyFilterState, serializeFilterState } from '../../commons/filters/GridFilterPanel.jsx';
import GridSearchResultsBadge from '../../commons/filters/GridSearchResultsBadge.jsx';
import GridColumnSelector from '../../commons/grid/GridColumnSelector.jsx';
import GridPagination from '../../commons/grid/GridPagination.jsx';
import SortableCell from '../../commons/grid/SortableCell.jsx';
import useColumnVisibility from '../../commons/grid/useColumnVisibility.js';
import useGridState from '../../commons/grid/useGridState.js';
import { GridToolbar, GridToolbarButton } from '../../commons/grid/GridToolbar.jsx';
import { GridLoadingRow } from '../../commons/grid/GridStateRow.jsx';
import { TICKETS_COLUMNAS_STORAGE_KEY, buildTicketsColumns } from './ticketsColumns.js';
import { buildTicketsQuery } from './ticketsGridQuery.js';
import {
	TICKETS_FILTROS_STORAGE_KEY,
	buildTicketsFilterFields,
	getTicketsFilterDefaults,
	migrarFiltrosPersistidos,
} from './ticketsFilterFields.js';


window.JSZip = jzip;
var pdfMake = require('pdfmake/build/pdfmake.js');
var pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const PAGINATION_INIT = {
	page: 0,
	count: 0,
	perPage: 10,
}

const FILTER_QUERY_INIT = {
	// VEC-3555: `entidad` es el texto libre (búsqueda parcial) y `entidades` los chips
	// resueltos, tipados como "Moviles:12,Llantas:5".
	entidad: "",
	entidades: "",
	vin: '',
	unidad: '',
	ticketTipo: 'DEFAULT',
	id: '',
	estado: 'PENDIENTES',
	fechaHoraAlta: '',
	fechaDesde: '',
	fechaHasta: '',
	fechaEnTaller: '',
	servicio: '',
	movilPersona: '',
	gerenciador: '',
	region: '',
	subRegion: [],
	base: '',
	pais: [],
	fechaRealizado: '',
	enTaller: '',
	detalle: '',
	abono: '',
	centroCostos: '',
	centroBeneficios: '',
	responsable1: '',
	encuestaNivelSatisfaccion: '',
	fechaHoraTurno: '',
	turnoAsignado: '',
	nivelAprobacionPresupuesto: '',
	tipoModelo: '',
	enTallerKpi: '',
	mttTotal: '',
	mttParcial: '',
	abono: '',
	origen: '',
	turnoInicio: '',
	turnoFinal: '',
	fechaPrometidaInicio: '',
	fechaPrometidaFinal: '',
	prioridad: '',
	transportadora: [],
	rentadora: [],
	clientExternalTicketId: '',
	usuarioCreacion: ''
}

const prioridadHabilitado = ConfigBusiness.get('tickets.servicios.prioridad.habilitado') === "true" || ConfigBusiness.get('tickets.tareas.prioridad.habilitado') === "true" ? true : false;

/**
 * Las columnas cuyo orden acepta el backend, en el objeto que espera el query (una clave por
 * columna). Antes esto era SORT_QUERY_INIT: 32 claves de las que 31 estaban siempre vacías,
 * más un handler que las reescribía todas para setear una. Ahora la lista declara qué se puede
 * ordenar y `useGridState` se encarga del resto.
 *
 * Son 30, no 32: `entidades` y `nivelAprobacionPresupuesto` estaban en SORT_QUERY_INIT pero
 * ningún endpoint acepta su orden, así que declararlas solo agregaba claves que nadie lee y
 * contradecía a sus columnas, que se renderizan sin `onSort`.
 */
const CAMPOS_DE_ORDEN = [
	'id',
	'ticketTipo',
	'estado',
	'fechaHoraAlta',
	'detalle',
	'servicio',
	'entidad',
	'unidad',
	'gerenciador',
	'region',
	'subRegion',
	'base',
	'pais',
	'centroCostos',
	'centroBeneficios',
	'responsable1',
	'enTaller',
	'encuestaNivelSatisfaccion',
	'fechaHoraTurno',
	'abono',
	'tipoModelo',
	'mttTotal',
	'mttParcial',
	'tiempoEnTaller',
	'fechaPrometida',
	'prioridad',
	'usuarioCreacion',
	'transportadora',
	'rentadora',
	'clientExternalTicketId',
]

/**
 * Con prioridad habilitada la grilla abre ordenada por prioridad descendente; si no, por
 * número de ticket descendente. Es el comportamiento que tenía SORT_QUERY_INIT.
 */
const ORDEN_INICIAL = prioridadHabilitado
	? { campo: 'prioridad', direccion: 'desc' }
	: { campo: 'id', direccion: 'desc' }

/**
 * Flags de config que habilitan columnas de la grilla y, con ellas, sus filtros.
 *
 * Se calcula de forma síncrona al montar y no en un efecto: la declaración de campos del
 * panel de filtros depende de estos flags, y el panel arma su estado inicial UNA sola vez
 * (hidratando localStorage). Si los flags llegaran un render después, los campos gateados
 * no tendrían entrada en ese estado y su valor persistido no se recuperaría.
 */
const buildColumnsEnabled = () => ({
	editKm: false,
	unidad: false,
	titular: false,
	companiaOrigen: false,
	cecosDireccion: false,
	cecosMercado: false,
	cecosGerencia: false,
	cecosArea: false,
	chasis: false,
	base: false,
	subRegion: false,
	region: ConfigBusiness.get('tickets.region.grilla') === 'true',
	pais: ConfigBusiness.get('tickets.pais.grilla') === 'true',
	centroCostos: ConfigBusiness.get('tickets.centroCostosGrilla.habilitado') === 'true',
	fechaEnTaller: ConfigBusiness.get('tickets.filtroFechaEnTaller.habilitado') === 'true',
	centroBeneficios: ConfigBusiness.get('tickets.centroBeneficiosGrilla.habilitado') === 'true',
	responsable1: ConfigBusiness.get('tickets.responsable1.habilitado') === 'true',
	encuestaSatisfaccion: ConfigBusiness.get('tickets.solicitarEncuestaSatisfaccion.grillaHabilitado') === 'true',
	fechaHoraTurno: ConfigBusiness.get('tickets.fechaHoraTurno.habilitado') === 'true',
	turnoAsignado: ConfigBusiness.get('tickets.fechaHoraTurno.habilitado') === 'true',
	abono: ConfigBusiness.get('mantenimientos.correctivo.abono.habilitado') === 'true',
	tipoModelo: ConfigBusiness.get('tickets.movil.modelo') === 'true',
	nivelAprobacionPresupuesto: ConfigBusiness.get('tickets.trabajaConNivelesDeAprobacion.grilla') === 'true',
	origen_checklist: ConfigBusiness.get('checklist.habilitado') === 'true',
	fechaPrometida: ConfigBusiness.get('tickets.fechaprometida.grilla') === 'true',
	mostrarTotalPresupuesto: ConfigBusiness.get('tickets.grilla.mostrar_total_presupuesto') === 'true',
	diasReparacion: ConfigBusiness.get('tickets.diasReparacion.grilla') === 'true',
	prioridad:
		ConfigBusiness.get('tickets.servicios.prioridad.habilitado') === 'true' ||
		ConfigBusiness.get('tickets.tareas.prioridad.habilitado') === 'true',
	transportadora: ConfigBusiness.get('moviles.transportadora.grilla') === 'true',
	rentadora: ConfigBusiness.get('frontend.rentadora.grilla') === 'true',
	clientExternalTicketId: ConfigBusiness.get('tickets.showExternalTicketId.habilitado') === 'true',
})

// VEC-3698: la key vieja `TicketsGridFilterNew` guardaba `{activo, filtros}`, donde
// `activo` era el switch "Persistir Filtros". El switch ya no existe (la persistencia es
// siempre) y el panel guarda el estado plano, así que lo que hubiera quedado se sube de
// nivel a la key nueva. Corre al importar el módulo, antes de que el panel de filtros lea
// localStorage al montar.
migrarFiltrosPersistidos()

const TicketsGrid = (props) => {
	const isTicketGridTable = ConfigBusiness.get('tickets.grilla.tabla_fuente') === 'ticket_grid' ? true : false;
	const intl = useIntl()
	const ticketsTipoStrings = localStorage.getItem('ticketsTipoStrings') ? JSON.parse(localStorage.getItem('ticketsTipoStrings')) : []
	const ticketsEstadoStrings = localStorage.getItem('ticketsEstadoStrings') ? JSON.parse(localStorage.getItem('ticketsEstadoStrings')) : []

	const [loading, setLoading] = useState(false)
	const [redirectTo, setRedirectTo] = useState(null)

	const [searchActive, setSearchActive] = useState(false)
	// Paginación y ordenamiento: src/commons/grid/useGridState.js. Expone `sortQuery` con una
	// clave por columna, que es lo que el backend espera, aunque adentro el estado sea una sola
	// columna ordenada.
	const {
		pagination,
		sort,
		sortQuery,
		requestSort,
		setPage,
		setPerPage,
		reset: resetGridState,
	} = useGridState({ campos: CAMPOS_DE_ORDEN, sortInicial: ORDEN_INICIAL, perPage: PAGINATION_INIT.perPage })
	const [paginationCount, setPaginationCount] = useState(0);

	// Señal para que el panel vuelva a sus defaults (la "✕" de la franja y el botón
	// Restaurar) y señal para imponerle un filtro desde las tarjetas de KPI.
	const [filterResetInputs, setFilterResetInputs] = useState(false)
	const [filterOverride, setFilterOverride] = useState(null)
	const [filterQuery, setFilterQuery] = useState(null)


	const [dropdownActive, setDropdownActive] = useState(false);

	const [tickets, setTickets] = useState([])
	const [estados, setEstados] = useState([])


	//Alarmas Controles
	const [estadisticas, setEstadisticas] = useState(null)

	//Enabled Columns Config
	const [columnsEnabled] = useState(buildColumnsEnabled)

	// Qué columnas se ven. Son DOS ejes distintos y el hook los combina en `columnasVisibles`:
	// `columnsEnabled` dice qué columnas existen para este cliente (config), y el selector del
	// toolbar dice cuáles de esas quiere ver el usuario. Las celdas consultan el combinado;
	// `columnsEnabled` queda para la lógica que no es de visibilidad (traer el total del
	// presupuesto, por ejemplo, que depende de que la columna exista y no de si está a la vista).
	const columnas = buildTicketsColumns(columnsEnabled)
	const {
		visibles: columnasVisibles,
		esVisible: columnaVisible,
		toggle: toggleColumna,
		mostrarTodas: mostrarTodasLasColumnas,
		seleccionables: columnasSeleccionables,
	} = useColumnVisibility(columnas, TICKETS_COLUMNAS_STORAGE_KEY)

	// Para las filas que ocupan la tabla entera (el spinner). Antes era un 13 escrito a mano,
	// con 38 columnas declaradas.
	const columnasALaVista = Object.keys(columnasVisibles).filter((nombre) => columnasVisibles[nombre]).length

	//Security Permissions
	const [permissions, setPermissions] = useState({
		canModifyKM: false,
		movilesVisualizar: false,
		movilesModificar: false,
		ticketsCrear: false,
		ticketsListar: false,
		vencimientosListar: false,
		vencimientosCrear: false,
		preventivosListar: false,
		correctivosCrear: false,
		ticketsModificar: false,
		ticketsVisualizar: false,
		ticketsCambiarPrioridad: false,
		ticketsGestionCC: false,
	})

	const [usuarioCCsGestionTickets, setUsuarioCCsGestionTickets] = useState([])

	const [modalExport, setModalExport] = useState(false)
	const [modalExportHistorico, setModalExportHistorico] = useState(false)
	const [stateImport, setStateImport] = useState(false)

	useEffect(() => {
		setLoading(true)
		if (Security.hasPermission("TICKETS_LISTAR")) {
			securityPermission()
			filterQuery && fetchTickets()

			getEstadisticas()
		} else {
			setRedirectTo("/error")
		}
		//componentWillUnmount
		return () => { }
	}, [pagination, filterQuery, sortQuery, stateImport])

	// Campos declarados del panel de filtros. Los usa la grilla para serializar su query
	// por defecto con las MISMAS reglas que aplica el panel; los callbacks del filtro de
	// Entidad no hacen falta acá (solo se serializa, no se renderiza).
	const filterFields = buildTicketsFilterFields(columnsEnabled, {})

	// Query por defecto: los campos vacíos más los defaults declarados (PENDIENTES, y el
	// tipo POR DEFECTO donde hay gestoría), sobre las claves que la grilla manda al backend
	// aunque no tengan input propio (fechaHoraAlta, movilPersona, filtroKpi...).
	const getDefaultFilterQuery = () => {
		const estado = Object.assign({}, buildEmptyFilterState(filterFields), getTicketsFilterDefaults(intl))
		return Object.assign({}, FILTER_QUERY_INIT, serializeFilterState(filterFields, estado))
	}

	// La franja de resultados se muestra solo si hay una búsqueda real, o sea si el query
	// difiere del default. Sin esta condición la franja quedaría visible siempre —el default
	// ya filtra por PENDIENTES— y la "✕" nunca podría ocultarla.
	const isFilterQueryNonDefault = (query) => {
		if (!query) return false
		const def = getDefaultFilterQuery()
		return Object.keys(def).some((key) => {
			const actual = query[key] === undefined || query[key] === null ? '' : String(query[key])
			const esperado = def[key] === undefined || def[key] === null ? '' : String(def[key])
			return actual !== esperado
		})
	}

	// Lo que el panel entrega al apretar "Buscar" (y al montar, con lo que hubiera
	// persistido). Se completa con FILTER_QUERY_INIT porque el panel solo serializa los
	// campos que declara, y getQuery() manda además claves sin input propio.
	const handleFilterApply = (query) => {
		const completo = Object.assign({}, FILTER_QUERY_INIT, query)
		const hayBusqueda = isFilterQueryNonDefault(completo)

		// Primer apply (el que hace el panel al montar con lo que tenía persistido): si esos
		// filtros no son el default, se abre el panel, para no dejar al usuario mirando un
		// listado filtrado sin ver por qué. Antes cumplía esa función el switch "Persistir
		// Filtros", que abría el panel cuando estaba prendido.
		if (filterQuery === null && hayBusqueda) setDropdownActive(true)

		setPage(0)
		setSearchActive(hayBusqueda)
		setFilterQuery(completo)
	}

	// LIMPIAR LA BÚSQUEDA — la "✕" de la franja de resultados. Vuelve los filtros al
	// default y oculta la franja, sin tocar el ordenamiento.
	const handleSearchClear = () => {
		localStorage.removeItem(TICKETS_FILTROS_STORAGE_KEY)
		setPage(0)
		setSearchActive(false)
		setFilterResetInputs(true)
		setFilterQuery(getDefaultFilterQuery())
	}

	const securityPermission = () => {
		let aux = { ...permissions }
		aux.ticketsCrear = Security.hasPermission('TICKETS_CREAR');
		aux.correctivosCrear = Security.hasPermission('MANTENIMIENTOS_CORRECTIVOS_CREAR');
		aux.gestoriaCrear = Security.hasPermission('TICKETS_GESTORIA_CREAR');
		aux.exportarHistorico = Security.hasPermission('TICKETS_EXPORTAR_HISTORICO');
		aux.ticketsListar = Security.hasPermission('TICKETS_LISTAR');
		aux.ticketsModificar = Security.hasPermission('TICKETS_MODIFICAR');
		aux.ticketsVisualizar = Security.hasPermission('TICKETS_VISUALIZAR');
		aux.ticketsCambiarPrioridad = Security.hasPermission('TICKETS_CAMBIAR_PRIORIDAD');
		aux.ticketsGestionCC = Security.hasPermission('TICKETS_GESTION_CC');
		setPermissions(aux)

		if (aux.ticketsGestionCC) {
			Utils.getData('/usuarios/cc-gestion-tickets').then((data) => {
				setUsuarioCCsGestionTickets(data.map(cc => cc.id));
			}).catch((err) => {
				console.log(err);
			});
		}
	}

	const getEstadisticas = () => {
		Utils.getData(`/tickets/estadisticas`).then((data) => {
			setEstadisticas(data)
		}).catch((err) => {
			console.log(err)
		})
	}
	const fetchTickets = () => {
		let url = isTicketGridTable ? "/ticket-grid" : "/tickets/newGrid";

		Promise.all([
			Utils.getData(url+`${getQuery()}`),
		])
			.then((data) => {
				setTickets(data[0].tickets)
				setLoading(false)
				setStateImport(false)
				setPaginationCount(data[0].pagination.count)
			})
			.catch((err) => {
				console.log(err)
				setLoading(false)
			})
	};

	const getQuery = () => buildTicketsQuery(pagination, filterQuery, sortQuery);

	const handleChangePage = (event, newPage) => setPage(newPage);

	const handleChangeRowsPerPage = (event) => setPerPage(parseInt(event.target.value, 10));


	// RESET TOTAL — el botón "Restaurar" del toolbar. Además de limpiar la búsqueda devuelve
	// el ordenamiento por defecto y cierra el panel. Reusa handleSearchClear para que el
	// cambio de filterQuery sea uno solo y no dispare dos consultas.
	const handleFilterReset = () => {
		resetGridState();
		setDropdownActive(false);
		// El reset del toolbar restaura la vista completa, así que también devuelve las
		// columnas ocultas. La "✕" de la franja NO lo hace: esa solo limpia la búsqueda.
		// Ver "los dos resets" en docs/design-system/grid-filter-panel.md.
		mostrarTodasLasColumnas();
		handleSearchClear();
	}

	const handleModalExportOpen = () => {
		setModalExport(true)
	};

	const handleModalExportClose = () => {
		setModalExport(false)
	};

	const handleModalHistoricoExportOpen = () => {
		setModalExportHistorico(true)
	};

	const handleModalHistoricoExportClose = () => {
		setModalExportHistorico(false)
	};

	// Clic en una tarjeta de KPI: reemplaza los filtros por el que representa la tarjeta.
	// Volver a clickear la que ya está aplicada la desactiva (vuelve a POR DEFECTO).
	// Los valores se le pasan también al panel, para que sus controles muestren el filtro
	// que se acaba de aplicar en vez de quedar mostrando el anterior.
	const handleFilter = (filter) => {
		// filterQuery es null hasta el primer apply del panel: sin filtro vigente, nada está
		// aplicado y la tarjeta simplemente aplica el suyo.
		const actual = filterQuery || {};
		// enTaller viaja como el string 'true' (es el value de su opción en el panel), así que
		// se compara como texto y no contra el boolean.
		const yaAplicado = actual['ticketTipo'] === filter || (filter === 'EN_TALLER' && String(actual['enTaller']) === 'true');

		let valores = {};
		if (yaAplicado) valores = { ticketTipo: 'DEFAULT' };
		else if (filter === 'EN_TALLER') valores = { enTaller: 'true' };
		else valores = { ticketTipo: filter };

		const query = Object.assign({}, FILTER_QUERY_INIT, valores);
		setPage(0);
		setSearchActive(isFilterQueryNonDefault(query));
		setFilterQuery(query);
		setFilterOverride(valores);
	}

	const handleExportComentariosPDF = async () => {
		const mostrarComentarios = false;

		const tablaBody = [];

		const rowData = tickets;
		// Obtener columnas desde Datatable
		/*
		const columnas = dt.settings().init().columns;
		const columnasSeleccionadas = Object.entries(columnas).filter(([i,v])=> dt.column(i).visible() && v.title);
		const tablaTitleProp = columnasSeleccionadas.map(([i,v])=>v.title);
		const tablaDataProp = columnasSeleccionadas.map(([i,v])=>v.data);
		*/
		const tablaTitleProp = Object.entries(tickets);
		const tablaDataProp = Object.values(tickets);

		let ticketComentarios = null;
		if (mostrarComentarios) {
			//Obtiene todos los comentarios de los ticketsId
			const rowsWithComments = rowData.filter((el) => el.comentario !== null).map((item) => item.id);
			ticketComentarios = await Promise.all(
				rowsWithComments.map(async (_ticketId) => {
					let _res = await this.ajaxHandler.getJson(`/ticket-comentarios/ticket/${_ticketId}/grid`)
					return {
						id: _ticketId,
						comentarios: _res.map(v => v.comentario)
					}
				})
			);
		}

		tablaBody.push(
			tickets[0].map((v, k) => {
				Object.entries(v).map(val => {
					return { text: 'Titulo', style: 'tabla_header' }
				})
			})
		);

		rowData.forEach((el) => {
			let fila = tablaDataProp.map(v => '');
			Object.entries(el).forEach(([i, v]) => {
				let obj = { style: 'tabla_row', text: v };
				if (tablaDataProp.includes(i)) {
					switch (i) {
						case 'fechaHoraAlta':
							obj.text = Timezone.getDateForClient(v, 'YYYY-MM-DD HH:mm:ss', 'L');
							break;
						case 'servicio':
							obj.text = v.nombre;
							break;
						case 'tipoEntidadColumnGrid':
							obj.text = v.descripcion;
							break;
						case 'gerenciador':
							obj.text = (v === null) ? '' : v.razonSocial;
							break;
						case 'base':
							obj.text = v.descripcion;
							break;
						case 'pais':
							obj.text = v.nombre;
							break;
						case 'subRegion':
							obj.text = v.nombre;
							break;
						default:
							obj.text = (v === null) ? '' : v;
							break;
					}
					fila[tablaDataProp.indexOf(i)] = obj;
				}
			});
			tablaBody.push(fila);

			// Adjunta comentarios
			if (mostrarComentarios && ticketComentarios != null) {
				if (el.comentario) {
					const row_comentarios = ticketComentarios.filter((v) => v.id === el.id).map(v => v.comentarios).shift();
					if (row_comentarios) {
						tablaBody.push([
							'',
							{ style: 'comentario', colSpan: tablaTitleProp.length - 1, text: row_comentarios.join('\n') },
						]);
					}
				}
			}
		});

		const file = {
			pageSize: {
				width: 842,
				height: 595
			},
			pageMargins: [30, 30, 30, 30],
			content: [
				{
					columns: [
						{
							alignment: 'left',
							image: LogoCompany,
							fit: [100, 100]
						},
						{
							alignment: 'right',
							image: LogoVecFleet,
							fit: [40, 40]
						},
					]
				},
				{
					text: intl.formatMessage({ id: 'ticketsGrid.print_content.header_listado_de_perfiles', defaultMessage: 'Listado de Tickets' }),
					style: 'header'
				},
				{
					style: 'tabla',
					table: {
						widths: tablaDataProp.map(col => (col === 'detalle') ? '*' : 'auto'),
						heights: 15,
						body: tablaBody
					},
					layout: 'noBorders'
				},
			],
			styles: {
				tabla: {
					margin: [0, 0, 0, 0]
				},
				tabla_header: {
					bold: true,
					color: 'white',
					fillColor: '#1D0D38'
				},
				tabla_row: {
					color: 'gray'
				},
				comentario: {
					bold: true,
				},
				header: {
					fontSize: 13,
					bold: true,
					margin: [0, 0, 0, 10]
				},
			},
			defaultStyle: {
				alignment: 'left',
				fontSize: 10
			}
		};

		pdfMake.createPdf(file).open();
	}

	const generacionMasiva = ConfigBusiness.get('tickets.generacionMasiva.habilitado') === 'true' ? true : false
	const [selectedTickets, setSelectedTickets] = useState([])
	const [allChecked, setAllCheked] = useState(false)
	const [showPopup, setShowPopup] = useState(false)
	const [ticketsAccionesMasivas, setTicketsAccionesMasivas] = useState({})
	const [amLoader, setAMLoader] = useState(false)

	const handleChecked = ticketId => e => {
		let selected = [...selectedTickets]

		if (ticketId == 'all') {
			selected = tickets.map(ticket => isTicketGridTable ? ticket.ticket_id : ticket.id)
			setAllCheked(true)

		} else if (ticketId == 'none') {
			selected = []
			setAllCheked(false)

		} else {
			let idx = selected.indexOf(ticketId)

			if (selected.includes(ticketId)) selected.splice(idx, 1)
			else selected.push(ticketId)
			setAllCheked(true)
		}
		setSelectedTickets(selected);
	}

	const checkTicketActions = () => {
		setAMLoader(true)
		Utils.sendData('/tickets/checkTicketActions/false', 'POST', selectedTickets)
			.then((data) => {
				setShowPopup(true);
				setTicketsAccionesMasivas(data);
				setAMLoader(false)
			}).catch((err) => {
				console.log(err)
			})
	}

	const [isTicketImportModalOpen, setIsTicketImportModalOpen] = useState(false);
	const [isTicketImportReportOpen, setIsTicketImportReportOpen] = useState(false);
	const [reporteImportacion, setReporteImportacion] = useState({ faltantes: [], mensajeImportacion: '' });


	const handleCloseTicketsImportReportModal = () => {
		setIsTicketImportReportOpen(!isTicketImportReportOpen);
	};

	const handleCloseTicketsImport = (message, faltantes = [], error = {}) => {

		setIsTicketImportModalOpen(!isTicketImportModalOpen);

		if (message !== "" && error) {
			if (error.codigo === 4010) {
				swal(
					this.props.intl.formatMessage({
						id: "preventivosGrid.alert.sesion_expiro",
						defaultMessage: "La sesión expiró"
					}),

					this.props.intl.formatMessage({
						id: "preventivosGrid.alert.ingrese_nuevamente",
						defaultMessage: "Por favor, ingrese nuevamente."
					}),

					"error"
				).then(() => {
					window.location.reload();
				});

			}

			else if (error.codigo) {
				swal(
					this.props.intl.formatMessage({
						id: "preventivosGrid.alert.error",
						defaultMessage: "Error"
					}),

					message,
					"error"
				);

			}

			else {
				swal(message, error, "error");
			}
		}

		else {
			if (faltantes["filas_fallaron"].length === 0) {
				swal(message, "", "success").then(() => {
					window.location.reload();
				});

			} else {

				// mostrar reporete de errores de importacion
				setReporteImportacion(faltantes);
				setIsTicketImportReportOpen(true);
			}
		}
	}

	return (
		<>
			{redirectTo && <Redirect push to={redirectTo} />}
			{estadisticas &&
				<>
					<TicketCards
						unclickable={showPopup}
						estadisticas={estadisticas}
						handleFilter={handleFilter}
					/>
					<br></br></>
			}
			{/* modal importador de tickets cerrados */}
			<Modal
				scrollable={true}
				open={isTicketImportModalOpen}
				onClose={handleCloseTicketsImport}
				closeAfterTransition
				BackdropProps={{
					timeout: 1000,
				}
				}
			>
				<Grow in={isTicketImportModalOpen}>
					<div className="col-8" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel1" style={{ margin: "auto" }}>
						<div className="modal-xl modal-dialog" role="document">
							<div className="modal-content">
								<div className="modal-header bg-fleet">
									<h4 className="modal-title text-white" id="myModalLabel1">
										<FormattedMessage id="ticketsGrid.tools.import.button.importar" defaultMessage=" Importar Ticket Cerrado" />
									</h4>
									<button type="button" className="close" onClick={() => handleCloseTicketsImport()} aria-label="Close"><span aria-hidden="true">&times;</span></button>
								</div>
								<div className="modal-body modal-grey">
									<form className="form">
										<TicketsCerradosImportar
											handleClose={handleCloseTicketsImport}
											callbackClose={handleCloseTicketsImport}
											callbackCancel={handleCloseTicketsImport}
										/>
									</form>
								</div>
							</div>
						</div>
					</div>
				</Grow>
			</Modal>
			{/* modal reporte de importador de tickets cerrados */}
			<Modal
				open={isTicketImportReportOpen}
				onClose={handleCloseTicketsImportReportModal}
				closeAfterTransition
				BackdropProps={{
					timeout: 1000,
				}
				}>
				<Grow in={isTicketImportReportOpen}>
					<div className="col-8" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel1" style={{ margin: "auto" }}>
						<div className="modal-xl modal-dialog" role="document">
							<div className="modal-content">
								<div className="modal-header bg-fleet">
									<h4 className="modal-title text-white" id="myModalLabel1">
										<FormattedMessage id="ticketsGrid.tools.import.button.reporte_filas_fallaron" defaultMessage=" Reporte filas que fallaron " />
									</h4>
									<button type="button" className="close" onClick={() => handleCloseTicketsImportReportModal()} aria-label="Close"><span aria-hidden="true">&times;</span></button>
								</div>
								<div className="modal-body modal-grey">
									<form className="form">
										<TicketsCerradosImportarReporte
											data={reporteImportacion}
											callbackClose={handleCloseTicketsImportReportModal}>
										</TicketsCerradosImportarReporte>
									</form>
								</div>
							</div>
						</div>
					</div>
				</Grow>
			</Modal>

			<TicketsGridExport
				open={modalExport}
				openHistorico={modalExportHistorico}
				handleClose={handleModalExportClose}
				handleModalHistoricoExportClose={handleModalHistoricoExportClose}
				queryFilters={filterQuery} />
			<div className={showPopup ? "card unclickable" : "card"}>
				<div className="card-content collpase show">
					<div className="card-body card-dashboard">
						<div className="container-fluid mb-1">
							<div className="row dt-icons">
								<div className="col">
									{
										!columnsEnabled.mantenimientosGestoria ?
											(
												<StyledTooltip
													title={intl.formatMessage({
														id: 'ticketsGrid.render.add_tickets.button_title_nuevo',
														defaultMessage: 'Nuevo',
													})}
													arrow
													placement="right"
												>
													<div
														className="btn btn-primary box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
														onClick={() => setRedirectTo('../correctivos/add')}
													>
														<i className="ft-plus"></i>
													</div>
												</StyledTooltip>
											)
											:
											(
												<>
													{
														permissions.ticketsCrear &&
														<StyledTooltip
															title={intl.formatMessage({
																id: 'movilesGrid.render.button_add.title_nuevo',
																defaultMessage: 'Nuevo',
															})}
															arrow
															placement="right"
														>
															<div
																className="btn btn-primary box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
																onClick={() => setRedirectTo(props.match.url + '/add')}
															>
																<i className="ft-plus"></i>
															</div>
														</StyledTooltip>
													}
													{
														permissions.correctivosCrear &&
														<StyledTooltip
															title={intl.formatMessage({
																id: 'ticketsGrid.render.add_tickets.button_title_nuevo_ticket_correctvo',
																defaultMessage: 'Nuevo Ticket Correctvo',
															})}
															arrow
															placement="right"
														>
															<div
																className="btn btn-success box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
																onClick={() => setRedirectTo('../correctivos/add')}
															>
																<i className="ft-plus"></i>
															</div>
														</StyledTooltip>
													}
													{
														permissions.gestoriaCrear &&
														<StyledTooltip
															title={intl.formatMessage({
																id: 'ticketsGrid.render.add_tickets.button_title_nuevo_ticket_de_gestoria',
																defaultMessage: 'Nuevo Ticket de Gestoría',
															})}
															arrow
															placement="right"
														>
															<div
																className="btn btn-success box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
																onClick={() => setRedirectTo('../ticketsgestoria/add')}
															>
																<i className="ft-plus"></i>
															</div>
														</StyledTooltip>
													}
												</>
											)
									}
									<div
										className="btn btn-grey-blue box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
										onClick={() => setDropdownActive(!dropdownActive)}
									>
										{dropdownActive ? <UpIcon /> : <ExpandMoreIcon />}
									</div>
								</div>
								<div className="col">
									{/* Franja de resultados compartida: src/commons/filters/GridSearchResultsBadge.jsx.
									    La "✕" limpia la búsqueda y NO toca el ordenamiento; el reset total es el
									    botón "Restaurar" del toolbar. */}
									<GridSearchResultsBadge
										visible={searchActive}
										mostrados={tickets.length}
										total={paginationCount}
										onReset={handleSearchClear}
									/>
								</div>
								<div className="col">
									<ButtonsTableTop
										permissions={permissions}
										columnasSeleccionables={columnasSeleccionables}
										columnaVisible={columnaVisible}
										toggleColumna={toggleColumna}
										handleModalExportOpen={handleModalExportOpen}
										handleModalHistoricoExportOpen={handleModalHistoricoExportOpen}
										handleFilterReset={handleFilterReset}
										handleExportComentariosPDF={handleExportComentariosPDF}
										handleCloseTicketsImport={handleCloseTicketsImport}
										isTicketGridTable={isTicketGridTable}
									/>
								</div>
							</div>
						</div>

						{/* Filtros sobre el panel compartido (VEC-3698):
						    src/commons/filters/GridFilterPanel.jsx, campos declarados en
						    ticketsFilterFields.js. El estado, la persistencia y la
						    serialización del query son del panel. */}
						<TicketGridFilters
							open={dropdownActive}
							columnsEnabled={columnsEnabled}
							loading={loading}
							onApply={handleFilterApply}
							resetSignal={filterResetInputs}
							onResetSignalHandled={() => setFilterResetInputs(false)}
							overrideValues={filterOverride}
							onOverrideHandled={() => setFilterOverride(null)}
						/>

						<TableContainer className={showPopup ? "min-height-35" : ''}>
							<Table aria-label="clases table" className="table-hover">
								{(generacionMasiva && tickets.length > 0 && selectedTickets.length > 0) ? (
									<TableHead>
										<TableRow>
											<StyledTableCell show={generacionMasiva && selectedTickets.length > 0} colSpan={18}>
												<input type="checkbox" checked={allChecked} onChange={handleChecked('none')} style={{ marginRight: "15px" }} className="customCheckbox" />
												<span style={{ marginRight: "10px" }}>{selectedTickets.length}</span>
												<FormattedMessage id="ticketsGrid.render.generacionMasiva.seleccionados" defaultMessage="Seleccionados " />
												|

												<StyledTooltip
													title={intl.formatMessage({
														id: 'render.generacionMasiva.cambio_de_estado',
														defaultMessage: 'Cambiar Estado',
													})}
													arrow
													placement="top"
												>
													<div style={{ marginLeft: "10px", position: 'relative', display: 'inline-block' }}>
														<span
															type="button"
															onClick={checkTicketActions}
															className="fa-stack fa-lg cursor-pointer"
														>
															<i className="fa fa-circle fa-stack-2x cursor-pointer"></i>
															<i className="fa fa-arrow-right fa-1_4x fa-stack-1x fa-inverse" style={{ color: "#241b3e" }}></i>
														</span>

														<AccionesMasivas
															show={showPopup}
															setShow={setShowPopup}
															tickets={ticketsAccionesMasivas}
															amLoader={amLoader}
															setAMLoader={setAMLoader}
															fetchTickets={fetchTickets}
															setSelectedTickets={setSelectedTickets}
														/>

													</div>
												</StyledTooltip>
											</StyledTableCell>
										</TableRow>
									</TableHead>
								) : (
									<TableHead>
										<TableRow>
											<StyledTableCell show={generacionMasiva && selectedTickets.length == 0} style={{ maxWidth: "22px" }}>
												<StyledTooltip
													title={intl.formatMessage({
														id: 'render.generacionMasiva.seleccionar_todos',
														defaultMessage: 'Seleccionar Todos',
													})}
													arrow
													placement="top"
												>
													<input type="checkbox" checked={allChecked} onChange={handleChecked('all')} style={{ marginRight: "15px" }} className="customCheckbox" />
												</StyledTooltip>
											</StyledTableCell>
											{/* ID */}
											<SortableCell show={columnasVisibles.ticketTipo} field="ticketTipo" sort={sort} onSort={requestSort} messageId="ticketsGrid.column_type.label_tipo" label="Tipo" />
											<SortableCell show={columnasVisibles.id} field="id" sort={sort} onSort={requestSort} messageId="ticketsGrid.column_Tkt.label_tkt" label="Tkt" />
											<SortableCell show={columnasVisibles.clientExternalTicketId} field="clientExternalTicketId" sort={sort} onSort={requestSort} messageId="ticketsGrid.column.label_clientExternalTicketId" label="OS" />
											<StyledTableCell show={columnasVisibles.indicador} align="left" onClick={() => requestSort("indicador")} style={{ cursor: "pointer" }}>
											</StyledTableCell>
											<SortableCell show={columnasVisibles.estado} field="estado" sort={sort} onSort={requestSort} messageId="ticketsGrid.column_state.label_estado" label="Estado" />
											<SortableCell show={columnasVisibles.prioridad} field="prioridad" sort={sort} onSort={requestSort} messageId="ticketsGrid.column_priority.label_prioridad" label="Prioridad" />
											{/* Sin onSort: ni /tickets/newGrid ni /ticket-grid aceptan el orden por esta
									    columna, y como requestSort limpia las demás claves, el click descartaba
									    el orden vigente sin aplicar ninguno. Ver VEC-3721. */}
											<SortableCell show={columnasVisibles.nivelAprobacionPresupuesto} field="nivelAprobacionPresupuesto" messageId="ticketsGrid.column_state.label_nivelAprobacionPresupuesto" label="Nivel Aprobación" />
											<SortableCell show={columnasVisibles.fechaHoraAlta} field="fechaHoraAlta" sort={sort} onSort={requestSort} messageId="ticketsGrid.column_create.label_creado" label="Creado" />
											<SortableCell show={columnasVisibles.usuarioCreacion} field="usuarioCreacion" sort={sort} onSort={requestSort} messageId="ticketsGrid.column_usuario_creacion.label_por" label="Por" />
											<SortableCell show={columnasVisibles.detalle} field="detalle" sort={sort} onSort={requestSort} messageId="ticketsGrid.column_detail.label_detalle" label="Detalle" />
											<SortableCell show={columnasVisibles.servicio} field="servicio" sort={sort} onSort={requestSort} messageId="ticketsGrid.column_service.label_servicio" label="Servicio" />
											<SortableCell show={columnasVisibles.entidad} field="entidad" sort={sort} onSort={requestSort} messageId="ticketsGrid.column_entity.label_entidad" label="Entidad" />
											<StyledTableCell show={columnasVisibles.vin} align="left">
												<FormattedMessage id="ticketsGrid.column_vin.label_vin" defaultMessage="VIN" />
											</StyledTableCell>
											<SortableCell show={columnasVisibles.unidad} field="unidad" sort={sort} onSort={requestSort} messageId="ticketsGrid.column_unidad.label_unidad" label="Unidad" />
											<SortableCell show={columnasVisibles.transportadora} field="transportadora" sort={sort} onSort={requestSort} messageId="ticketsGrid.column.label_transportadora" label="Transportadora" />
											<SortableCell show={columnasVisibles.rentadora} field="rentadora" sort={sort} onSort={requestSort} messageId="ticketsGrid.column.label_rentadora" label="Rentadora" />
											<SortableCell show={columnasVisibles.gerenciador} field="gerenciador" sort={sort} onSort={requestSort} messageId="ticketsGrid.column_gerenciador.label_gerenciador" label="Gerenciador" />
											<StyledTableCell show={columnasVisibles.mostrarTotalPresupuesto} align="left">
												<FormattedMessage id="ticketsGrid.column_total.label_total" defaultMessage="Total del Presupuesto" />
											</StyledTableCell>
											<SortableCell show={columnasVisibles.region} field="region" sort={sort} onSort={requestSort} messageId="ticketsGrid.column_region.label_region" label="Región" />
											<SortableCell show={columnasVisibles.subRegion} field="subRegion" sort={sort} onSort={requestSort} messageId="ticketsGrid.column_region.label_subRegion" label="SubRegión" />
											<SortableCell show={columnasVisibles.base} field="base" sort={sort} onSort={requestSort} messageId="ticketsGrid.column_base.label_base" label="Base" />
											<SortableCell show={columnasVisibles.pais} field="pais" sort={sort} onSort={requestSort} messageId="ticketsGrid.column_pais.label_pais" label="Pais" />
											<SortableCell show={columnasVisibles.centroCostos} field="centroCostos" sort={sort} onSort={requestSort} messageId="ticketsGrid.column_cost_center.label_centro_de_costos" label="Centro de Costos" />
											<SortableCell show={columnasVisibles.centroBeneficios} field="centroBeneficios" sort={sort} onSort={requestSort} messageId="ticketsGrid.column_titular.label_titular" label="Titular" />
											<SortableCell show={columnasVisibles.responsable1} field="responsable1" sort={sort} onSort={requestSort} messageId="Responsable" label="Responsable" />
											<SortableCell show={columnasVisibles.enTaller} field="enTaller" sort={sort} onSort={requestSort} messageId="Taller" label="Taller" />
											<SortableCell show={columnasVisibles.fechaPrometida} field="fechaPrometida" sort={sort} onSort={requestSort} messageId="Fecha_promesa" label="Fecha promesa" />
											<StyledTableCell show={columnasVisibles.diasReparacion} align="left" style={{ cursor: "pointer" }}>
												<FormattedMessage id="Dias_reparacion" defaultMessage="Días de Reparación" />
											</StyledTableCell>
											<SortableCell show={columnasVisibles.mttTotal} field="mttTotal" sort={sort} onSort={requestSort} messageId="ticketsGrid.column_TT.label_TT" label="TT" />
											<SortableCell show={columnasVisibles.mttParcial} field="mttParcial" sort={sort} onSort={requestSort} messageId="ticketsGrid.column_TP.label_TP" label="TP" />
											<SortableCell show={columnasVisibles.tiempoEnTaller} field="tiempoEnTaller" sort={sort} onSort={requestSort} messageId="ticketsGrid.column_tiempoEnTaller.label" label="Tiempo en taller" />
											<SortableCell show={columnasVisibles.encuestaSatisfaccion} field="encuestaNivelSatisfaccion" sort={sort} onSort={requestSort} messageId="ticketsGrid.column_encuesta.label_encuesta" label="Satisfacción" />
											{/* Sin onSort: ni /tickets/newGrid ni /ticket-grid aceptan el orden por esta
									    columna, y como requestSort limpia las demás claves, el click descartaba
									    el orden vigente sin aplicar ninguno. Ver VEC-3721. */}
											<SortableCell show={columnasVisibles.fechaRealizado} field="fechaRealizado" messageId="ticketsGrid.column_realized.label_realizado" label="Realizado" />
											<SortableCell show={columnasVisibles.fechaHoraTurno} field="fechaHoraTurno" sort={sort} onSort={requestSort} messageId="ticketsGrid.column_state.label_fecha_hora_turno" label="Turno" />
											<SortableCell show={columnasVisibles.abono} field="abono" sort={sort} onSort={requestSort} messageId="ticketsGrid.column_abono.label_abono" label="Abono" />
											<SortableCell show={columnasVisibles.tipoModelo} field="tipoModelo" sort={sort} onSort={requestSort} messageId="ticketsGrid.column_tipo_modelo.lable_tipo_modelo" label="Tipo Modelo" />
											<StyledTableCell show={columnasVisibles.acciones} align="left"><FormattedMessage id="movilesGrid.rennder.column_acciones.label" defaultMessage="Acciones" /></StyledTableCell>
										</TableRow>
									</TableHead>
								)}
								<TableBody >
									<GridLoadingRow visible={loading} columns={columnasALaVista} />
									{!loading && (
										tickets.length > 0 ?
										tickets.map((ticket) => {
												const ticketId = isTicketGridTable ? ticket.ticket_id : ticket.id;
												const centroCostoId = ticket.centro_costos ? (ticket.centro_costos.id || ticket.centro_costos) : null;
												const tienePermisoGestionCC = permissions.ticketsGestionCC;
												const puedeEditarCC = !centroCostoId || !tienePermisoGestionCC || usuarioCCsGestionTickets.includes(centroCostoId);
												const ticketUrl = puedeEditarCC ? `${props.match.url}/${ticketId}/edit` : `${props.match.url}/${ticketId}`;
												
												return isTicketGridTable ? (
													<TicketsGridTableRow
														columnsEnabled={columnsEnabled}
														columnasVisibles={columnasVisibles}
														permissions={permissions}
														usuarioCCsGestionTickets={usuarioCCsGestionTickets}
														key={'ticketsGridFullRow_' + ticket.id}
														baseUrl={props.match.url}
														ticketUrl={ticketUrl}
														ticket={ticket}
														ticketEstado={ticketsEstadoStrings[ticket.estado]}
														ticketTipo={ticketsTipoStrings[ticket.tipo]}
														generacionMasiva={generacionMasiva}
														selectedTickets={selectedTickets}
														setSelectedTickets={setSelectedTickets}
														handleChecked={handleChecked}
													/>
												) : (
													<TicketsGridRow
														columnsEnabled={columnsEnabled}
														columnasVisibles={columnasVisibles}
														permissions={permissions}
														usuarioCCsGestionTickets={usuarioCCsGestionTickets}
														key={'ticketsGridRow_' + ticket.id}
														baseUrl={props.match.url}
														ticketUrl={ticketUrl}
														ticket={ticket}
														ticketEstado={ticketsEstadoStrings[ticket.estado]}
														ticketTipo={ticketsTipoStrings[ticket.ticket_tipo]}
														generacionMasiva={generacionMasiva}
														selectedTickets={selectedTickets}
														setSelectedTickets={setSelectedTickets}
														handleChecked={handleChecked}
													/>
												)
											}) :
											<TableRow>
												<StyledTableCell colSpan={18} align="center">
													<FormattedMessage id="movilesGrid.rennder.no_data_table" defaultMessage="No se encontraron resultados..." />
												</StyledTableCell>
											</TableRow>
									)}
								</TableBody>
							</Table>
						</TableContainer>
						<GridPagination
							count={paginationCount}
							page={pagination.page}
							perPage={pagination.perPage}
							onPageChange={handleChangePage}
							onPerPageChange={handleChangeRowsPerPage}
						/>
					</div>
				</div>
			</div>

		</>
	)
}

const ButtonsTableTop = (props) => {
	return (
		<GridToolbar>
			{props.isTicketGridTable ? (
				<GridToolbarButton title="Grilla en test" icon="fas fa-user-secret" />
			) : null}

			<GridToolbarButton
				messageId="ticketsGrid.tools_restore_filters.title_restaurar_filtros_y_ordenamiento"
				label="Restaurar filtros y ordenamiento"
				onClick={() => props.handleFilterReset()}
			>
				<img id="filterReset" className="filter-reset" src={LimpiarFiltros} alt="" />
			</GridToolbarButton>

			{/* Selector de columnas compartido: src/commons/grid/GridColumnSelector.jsx.
			    Mismo lugar y mismo aspecto que el botón colvis de las grillas de DataTables. */}
			<GridColumnSelector
				columns={props.columnasSeleccionables}
				esVisible={props.columnaVisible}
				onToggle={props.toggleColumna}
			/>

			{/* El export no se parametriza en el patrón: cada grilla resuelve el suyo. Acá es un
			    desplegable con dos destinos, así que va como hijo del toolbar. */}
			<div className="dropdown">
				<GridToolbarButton
					messageId="movilesGrid.tools_export.title_exportar_a_excel"
					label="Exportar a Excel"
					icon="ft-upload"
					className="btn buttons-collection"
					dropdownToggle
					id="dropdownMenu2"
				/>
				<div className="dropdown-menu" aria-labelledby="dropdownMenu2">
					<button style={{ fontSize: '15px' }} onClick={() => props.handleModalExportOpen()} className="btn btn-secondary buttons-collection" type="button">
						<span>
							<FormattedMessage id="ticketsGrid.render.export_modal.header_exportar_tickets" defaultMessage="Exportar Tickets" />
						</span>
					</button>
					<button style={{ fontSize: '15px' }} onClick={() => props.handleModalHistoricoExportOpen()} className="btn btn-secondary buttons-collection" type="button">
						<span>
							<FormattedMessage id="ticketsGrid.tools_export.title_export_historico" defaultMessage="Exportar Histórico de Estados de Tickets" />
						</span>
					</button>
				</div>
			</div>

			{Security.hasPermission('TICKETS_IMPORTAR_CERRADOS') ? (
				<GridToolbarButton
					messageId="ticketsGrid.render.importar.button_ticket_importar_tickets"
					label="Importar ticket cerrado"
					icon="ft-download"
					onClick={() => props.handleCloseTicketsImport()}
				/>
			) : null}
		</GridToolbar>
	)
}






export default TicketsGrid
